export default "__VITE_ASSET__Bmt3UUpx__"